import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";

interface LineChartProps {
  data: {
    categories: string[];
    series: {
      name: string;
      data: number[];
    }[];
  };
  height?: number;
  className?: string;
}

const LineChart: React.FC<LineChartProps> = ({
  data,
  height = 350,
  className = "",
}) => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const options = {
      series: data.series,
      chart: {
        height: height,
        type: "line",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        background: "transparent",
        fontFamily: "inherit",
      },
      colors: ["#3B82F6", "#10B981"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      grid: {
        borderColor: "#1C252E",
        strokeDashArray: 4,
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      xaxis: {
        categories: data.categories,
        labels: {
          style: {
            colors: "#9CA3AF",
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#9CA3AF",
          },
        },
      },
      tooltip: {
        theme: "dark",
        x: {
          format: "dd MMM yyyy",
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        labels: {
          colors: "#9CA3AF",
        },
      },
    };

    const chart = new ApexCharts(chartRef.current, options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [data, height]);

  return <div ref={chartRef} className={className} />;
};

export default LineChart;
